import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles(theme => ({
	chatTabs: {
		position: "relative",
		"&::before": {
			content: "close-quote",
			position: "absolute",
			width: "100%",
			height: "1px",
			bottom: 0,
			left: 0,
			...ColorUtil.getBackgroundAndContrastColor(colors.gray[200])
		}
	},
	chatTab: {
		color: `${colors.gray[700]} !important`,
		fontSize: 12
	},
	chatTabIndicator: {
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[700])
	},
	chatSubTabs: {
		padding: theme.spacing(2),
		width: "100%",
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[0])
	},
	chatSubTab: {
		textTransform: "none",
		...ColorUtil.getBackgroundAndContrastColor(colors.blue[100]),
		borderRadius: theme.spacing(0.5),
		"&:not(:last-child)": {
			marginRight: theme.spacing(0.5)
		}
	},
	chatSubTabIndicator: {
		...ColorUtil.getBackgroundAndContrastColor("transparent")
	},
	disableTab: {
		color: colors.gray[700],
		boxShadow: "none",
		opacity: 0.7,
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
		gap: 2
	},
	infoIcon: {
		width: 16,
		height: 16
	}
}))

export default useStyles
